/* eslint-disable camelcase */
import { ConfiguredNotificationsApi } from 'api/index';
import logger from 'helpers/logger';
import { UserManager } from 'oidc-client-ts';
import localStorageHelper from 'helpers/localStorageHelper';

import { oidcConfiguration } from '../../config/appConfig';

export const getUserManager = (environmentProperties) => {
    if (!environmentProperties) {
        return null;
    }
    const {
        openIDClientID,
        openIDIssuer
    } = environmentProperties;

    const authConfig = { ...oidcConfiguration };

    authConfig['client_id'] = openIDClientID;
    authConfig['authority'] = openIDIssuer;

    const userManager = new UserManager(authConfig);

    // Sync OIDC client tokens to localStorage authenticated_user object
    const syncTokensToLocalStorage = (user) => {
        if (user?.access_token) {
            const authKey = `authenticated_user:${openIDIssuer}:${openIDClientID}`;

            const tokenData = {
                access_token: user.access_token,
                refresh_token: user.refresh_token,
                id_token: user.id_token,
                token_type: user.token_type,
                scope: user.scope,
                expires_at: user.expires_at,
                session_state: user.session_state
            };

            localStorageHelper.nonEncrypted.setItem(authKey, tokenData);
            logger.info('OIDC tokens synced to localStorage');
        }
    };

    userManager.events.addUserLoaded(syncTokensToLocalStorage);

    const originalStoreUser = userManager.storeUser.bind(userManager);
    userManager.storeUser = async function (user) {
        const result = await originalStoreUser(user);
        if (user) {
            syncTokensToLocalStorage(user);
        }
        return result;
    };

    return userManager;
};

export const formatLanguageResource = (applangaResources, localResources = null) => {
    const resources = localResources || applangaResources;

    return {
        'ABB': {
            'Powertrain': {
                'Frontend': {
                    ...resources?.ABB?.Powertrain?.Frontend
                },
                'Backend': {
                    'Notification': {
                        ...applangaResources?.ABB?.Powertrain?.Backend?.Notification
                    },
                    'Analytics': {
                        ...resources?.ABB?.Powertrain?.Backend?.Analytics
                    },
                    'Timeseries': {
                        ...applangaResources?.ABB?.Powertrain?.Backend?.Timeseries
                    }
                }
            },
            'CMD': {
                'Backend': {
                    'KPI': {
                        ...applangaResources?.ABB?.CMD?.Backend?.KPI
                    },
                    'AssetProperty': {
                        ...applangaResources?.ABB?.CMD?.Backend?.AssetProperty
                    }
                }
            },
            'SmartSensor': {
                'Backend': {
                    'KPI': {
                        ...applangaResources?.ABB?.SmartSensor?.Backend?.KPI
                    },
                    'AssetProperty': {
                        'Name': {
                            ...applangaResources?.ABB?.SmartSensor?.Backend?.AssetProperty?.Name
                        },
                    },
                    'IssueType': {
                        ...applangaResources?.ABB?.SmartSensor?.Backend?.IssueType
                    },
                    'IssueSubtype': {
                        ...applangaResources?.ABB?.SmartSensor?.Backend?.IssueSubtype
                    }
                }
            },
            'Motion': {
                'Powertrain': {
                    'TypeConfig': {
                        ...applangaResources?.ABB?.Motion?.Powertrain?.TypeConfig
                    }
                }
            }
        }
    };
};

export const approveBroadcastedMessageHandler = (messageID, userID) => {
    ConfiguredNotificationsApi
        .removeBroadcastedMessageForUser(messageID, userID)
        .catch((err) => {
            return err ? logger.error(err.message) : null;
        });
};
